import { BlacklistQueriesAPI } from "@radarly/api/blacklist-queries";
import {
  BlacklistQuery,
  SaveBlacklistQueriesRequest,
  SearchBlacklistQueriesRequest,
} from "@radarly/models/blacklist-queries";
import {
  BlacklistQueriesRepository,
  Pagination,
} from "./BlacklistQueriesRepository";

interface Dependencies {
  blacklistQueriesAPI: BlacklistQueriesAPI;
}

export class ConnectedBlacklistQueriesRepository
  implements BlacklistQueriesRepository
{
  private blacklistQueriesAPI: BlacklistQueriesAPI;
  constructor(dependencies: Dependencies) {
    this.blacklistQueriesAPI = dependencies.blacklistQueriesAPI;
  }

  public async searchBlacklistQueries(
    project: number,
    payload: SearchBlacklistQueriesRequest
  ) {
    return await this.blacklistQueriesAPI.searchBlacklistQueries(
      project,
      payload
    );
  }

  public async getBlacklistQuery(project: number, qid: number) {
    return await this.blacklistQueriesAPI.getBlacklistQuery(project, qid);
  }

  public async createBlacklistQuery(
    project: number,
    payload: SaveBlacklistQueriesRequest
  ) {
    return await this.blacklistQueriesAPI.createBlacklistQuery(
      project,
      payload
    );
  }
  public async updateBlacklistQuery(
    project: number,
    qid: number,
    query: BlacklistQuery
  ) {
    return await this.blacklistQueriesAPI.updateBlacklistQuery(
      project,
      qid,
      query
    );
  }
  public async deleteBlacklistQuery(project: number, qid: number) {
    return await this.blacklistQueriesAPI.deleteBlacklistQuery(project, qid);
  }

  public async getBlacklistQueryChangeLog(
    project: number,
    focus: number,
    pagination: Pagination
  ): Promise<{ changelog: any[]; total: number }> {
    return await this.blacklistQueriesAPI.getBlacklistQueryChangeLog(
      project,
      focus,
      pagination
    );
  }
}
